<template>
  <a-card class="m-display-flex flex-column nowrap">
    <span slot="title">{{ mode }} SPPD/S</span>
    <a-steps :current="current" status="process">
      <a-step title="Information" />
      <a-step title="PD/S Detail" />
      <a-step title="PD/S Assignment" />
      <a-step title="Approval" />
    </a-steps>
    <div class="steps-content flex-1">
      <component
        class="flex-1"
        :is="steps[current].content"
        v-bind="stepProps"
        :ref="stepRef"
      ></component>
    </div>
    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button
          v-if="current < steps.length - 1"
          type="primary"
          @click="next"
          :loading="loadingNext"
          >Next</a-button
        >
        <a-button
          :loadin="btnLoading"
          v-if="current == steps.length - 1"
          type="primary"
          @click="validate"
          >{{ mode == "Create" ? "Save" : "Save Changes" }}</a-button
        >
        <a-button v-if="current > 0" @click="prev">Previous</a-button>
      </div>
    </template>
  </a-card>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import Informasi from "./Informasi.vue";
import Detail from "./DetailPembelian.vue";
import PerintahKerja from "./PerintahKerja.vue";
import Persetujuan from "./Persetujuan.vue";

export default {
  name: "sppdNew",
  props: ["id"],
  components: {
    Informasi,
    Detail,
    PerintahKerja,
    Persetujuan,
  },
  data() {
    return {
      current: 0,
      steps: [
        {
          title: "Informasi",
          content: "Informasi",
        },
        {
          title: "Detail",
          content: "Detail",
        },
        {
          title: "Perintah Kerja",
          content: "PerintahKerja",
        },
        {
          title: "Persetujuan",
          content: "Persetujuan",
        },
      ],
      sendData: [],
      postData: new FormData(),
      mode: "Create",
      dataDetail: [],
      pushData: {},
      postJson: {},
      btnLoading: false,
      projectAllsts: [],
      listPembelian: [],
      mata_uang: "IDR",
      loadingNext: false,
    };
  },
  computed: {
    ...mapGetters(["getScreen", "getAuth"]),
    stepPushListPembelian() {
      let data = [];
      // NEW
      this.listPembelian.forEach((item, index) => {
        data = [
          ...data,
          {
            no: index + 1,
            kode_anggaran: item.kode_anggaran,
            item_detail: item.item_detail,
            path: item.path,
            id_anggaran: item.id_anggaran,
            kode_anggaran_dtl: item.kode_anggaran_dtl,
            oldvalue: item.oldvalue,
            pemakaian: item.pemakaian,
            id_sppd_dtl: item.id_sppd_dtl,
            nilai: item.nilai,
            bailout_value: item.bailout_value
          },
        ];
      });

      return data;
    },
    stepProps: function () {
      if (this.steps[this.current].content === "Informasi") {
        return {
          data: this.pushData.informasi,
          projectAllsts: this.projectAllsts,
          mode: this.mode,
          id: this.id,
          listPembelian: this.listPembelian,
        };
      } else if (this.steps[this.current].content === "Detail") {
        return {
          listPembelian: this.stepPushListPembelian,
          informasi: this.pushData.informasi,
          mode: this.mode,
          id: this.id,
          mata_uang: this.mata_uang,
        };
      } else if (this.steps[this.current].content === "PerintahKerja") {
        return {
          data: this.pushData.perintahkerja,
          pimpro_atasan: this.pushData.pimpro_atasan,
          projectAllsts: this.projectAllsts,
          mode: this.mode,          
          id: this.id,
        };
      } else if (this.steps[this.current].content === "Persetujuan") {
        return {
          data: this.pushData.persetujuan,
          pimpro_atasan: this.pushData.pimpro_atasan,
          projectAllsts: this.projectAllsts,
          mode: this.mode,
          informasi: this.pushData.informasi,
          approvalDetail: this.pushData.approval,
          bod: this.pushData.bod,
        };
      }
      return true;
    },
    stepRef: function () {
      if (this.steps[this.current].content === "Informasi") {
        return "refInformasi";
      } else if (this.steps[this.current].content === "PerintahKerja") {
        return "refPerintahkerja";
      } else if (this.steps[this.current].content === "Detail") {
        return "refDetailPembelian";
      } else {
        return "refPersetujuan";
      }
    },
  },
  created() {
    if (this.id) {
      this.mode = "Edit";
      this.fetchData();
    }
  },

  methods: {
    ...mapActions([
      "FETCH_ALLOCATION",
      "FETCH_USEDFOR",
      "FETCH_ALL_KARYAWAN",
      "FETCH_GA",
      "FETCH_VPM",
    ]),
    getFromChildBackPersetujuan(value) {
      this.pushData.persetujuan = JSON.parse(JSON.stringify(value.persetujuan));
    },
    getFromChildBackPerintahKerja(value) {
      this.pushData.perintahkerja = JSON.parse(
        JSON.stringify(value.perintahkerja)
      );
    },
    getFromChild(value) {
      if (this.steps[this.current].content === "Informasi") {
        this.pushData.informasi = JSON.parse(JSON.stringify(value.informasi));

        this.current++;
      } else if (this.steps[this.current].content === "PerintahKerja") {
        this.pushData.perintahkerja = JSON.parse(
          JSON.stringify(value.perintahkerja)
        );
        this.pushData.bod = value.bod;
        this.current++;
      } else if (this.steps[this.current].content === "Persetujuan") {
        this.pushData.persetujuan = JSON.parse(
          JSON.stringify(value.persetujuan)
        );
        if (this.mode === "Edit") {
          this.confirmMessage("confirm-edit");
        } else {
          this.confirmMessage("confirm-save");
        }
      } else if (this.steps[this.current].content === "Detail") {
        this.pushData.approval = JSON.parse(JSON.stringify(value));
        this.current++;
      }
    },
    next() {
      if (this.steps[this.current].content === "Informasi") {
        this.$refs.refInformasi.handleRef();
      } else if (this.steps[this.current].content === "PerintahKerja") {
        this.$refs.refPerintahkerja.handleRef();
      } else if (this.steps[this.current].content === "Detail") {
        this.$refs.refDetailPembelian.handleRef();
      }
    },
    prev() {
      if (this.steps[this.current].content === "Persetujuan") {
        this.$refs.refPersetujuan.handleRefBackPersetujuan();
      } else if (this.steps[this.current].content === "PerintahKerja") {
        this.$refs.refPerintahkerja.handleRefBackPerintahKerja();
      }
      this.current--;
    },
    setSubmitForm() {
      let kode_anggaran = [];
      let dtl_item = [];
      let path = [];
      let id_sppd_dtl = [];
      let value = [];
      let bailout_value = [];

      this.listPembelian.forEach((item) => {
        let lastAnggaran = item.id_anggaran.split(";");
        kode_anggaran.push(lastAnggaran[2]);
        dtl_item.push(item.item_detail);
        path.push(item.path);
        id_sppd_dtl.push(item.id_sppd_dtl);
        value.push(item.nilai);
        bailout_value.push(item.bailout_value);
      });
      this.postJson = {
        tlc: this.getAuth.username,
        kode_anggaran_dtl: kode_anggaran,
        item_dtl: dtl_item,
        path: path,
        id_sppd_dtl: id_sppd_dtl,
        value : value,
        bailout_value: bailout_value,
        jenis_perintah: this.pushData.informasi.jenis_perintah,
        start_jadwal_sppds: this.pushData.informasi.jadwalDinas[0],
        end_jadwal_sppds: this.pushData.informasi.jadwalDinas[1],
        deskripsi_sppds: this.pushData.informasi.deskripsi_sppds,
        tanggal_sppds: this.pushData.informasi.tanggal_sppds,
        // estimated_cost:  this.pushData.informasi.est_cost,

        akomodasi_sppds: this.pushData.perintahkerja.akomodasi_sppds,
        alamat_sppds: this.pushData.perintahkerja.alamat_sppds,
        assignee_sppds: this.pushData.perintahkerja.assignee_sppds,
        cp_sppds: this.pushData.perintahkerja.cp_sppds,
        satuankerja_sppds: this.pushData.perintahkerja.satuankerja_sppds,
        transport_sppds: this.pushData.perintahkerja.transport_sppds,

        catatan_sppds: this.pushData.persetujuan.catatan_sppds,
        pipeline: this.pushData.informasi.pipeline_id?this.pushData.informasi.pipeline_id:null,
        activity: this.pushData.informasi.activity ? this.pushData.informasi.activity : null,
        type_activity: this.pushData.informasi.activity_type ? this.pushData.informasi.activity_type : null
      };

      if(this.pushData.informasi.prospek){
        this.postJson['prospek'] = this.pushData.informasi.prospek
      }

      if (this.mode == "Edit") {
        this.postJson.id_sppd = this.pushData.detail.id_sppds;
      } else {
        this.postJson.approval = this.pushData.persetujuan.approval;
      }
    },
    submit() {
      this.setSubmitForm();

      this.btnLoading = true;
      axios({
        method: this.mode == "Create" ? "post" : "put",
        url: this.$serviceUrl + "sppds/v2",
        data: this.postJson,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          if (response.data.message === "berhasil insert") {
            this.displayMessage("success-save");
          } else if (response.data.message === "berhasil edit") {
            this.displayMessage("success-edit");
          } else {
            let responses = Object.assign({}, response.data);
            this.displayMessageValue("error", responses);
          }

          Event.$emit("clearFormSppds");
          this.btnLoading = false;
          this.sendData = [];
          this.current = 0;
          this.$router.go(-1);
        })
        .catch((err) => {
          this.btnLoading = false;
          let response = Object.assign({}, err.response.data);
          this.displayMessageValue("error", response);
        });
    },
    validate() {
      this.$refs.refPersetujuan.handleRef();
    },

    getListPembelian(item) {
      this.listPembelian = [
        ...this.listPembelian,
        JSON.parse(JSON.stringify(item.values)),
      ];
      // this.$refs.refDetailPembelian.recountingAnggaran(this.listPembelian)
    },

    getUpdatePembelian(item) {
      this.listPembelian = item.data;
    },
    remoteDetail(item) {
      if (item.index > -1) {
        this.listPembelian.splice(item.index, 1);
      }
    },
    fetchData() {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: this.$serviceUrl + "sppds/SppdsDetil_V2",
          params: {
            id_sppd: this.id,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.pushData = {
              informasi: {
                ...response.data.detail_sppds[1].informasi,
                jadwalDinas: [
                  response.data.detail_sppds[1].informasi.start_jadwal_sppds,
                  response.data.detail_sppds[1].informasi.end_jadwal_sppds,
                ],
                actorApproval: response.data.list_approval,
              },
              perintahkerja: response.data.detail_sppds[2].perintahkerja,
              persetujuan: response.data.detail_sppds[3].persetujuan,
              detail: response.data.detail_sppds[0],
            };

            // this.listPembelian

            response.data.item_sppds.forEach((item) => {
              this.listPembelian.push({
                kode_anggaran: item.kode_anggaran,
                item_detail: item.item_nm,
                id_anggaran:
                  item.peruntukan +
                  ";" +
                  item.sub_peruntukan +
                  ";" +
                  item.anggaran_dtl_val_id,
                pemakaian: item.pemakaian,
                id_sppd_dtl: item.id_sppd_dtl,
                path: item.path,
                nilai: item.value,
                bailout_value: item.bailout_value
              });
            });

            resolve(response);
          })
          .catch((err) => {
            let response = Object.assign({}, err.response.data);
            this.displayMessageValue("error", response);
            reject(err);
          });
      });
    },
    handleLoadingNext(value) {
      this.loadingNext = value;
    },
  },

  mounted() {
    // this.fetchData().then( ));
    this.FETCH_ALLOCATION();
    this.FETCH_USEDFOR();
    this.FETCH_ALL_KARYAWAN();
    this.FETCH_GA();
    this.FETCH_VPM();
    Event.$on("collectData", this.getFromChild);
    Event.$on("collectDataBackPersetujuan", this.getFromChildBackPersetujuan);
    Event.$on(
      "collectDataBackPerintahKerja",
      this.getFromChildBackPerintahKerja
    );
    Event.$on("confirmMessageReturn", this.submit);
    Event.$on("listPembelian", this.getListPembelian);
    Event.$on("updateListXML", this.getUpdatePembelian);
    Event.$on("deleteDetail", this.remoteDetail);
    Event.$on("handleLoadingNext", this.handleLoadingNext);
  },
  beforeDestroy() {
    Event.$off("collectData", this.getFromChild);
    Event.$off("collectDataBackPersetujuan", this.getFromChildBackPersetujuan);
    Event.$off(
      "collectDataBackPerintahKerja",
      this.getFromChildBackPerintahKerja
    );
    Event.$off("confirmMessageReturn", this.submit);
    Event.$off("listPembelian", this.getListPembelian);
    Event.$off("deleteDetail", this.remoteDetail);
  },
};
</script>

<style lang="less"></style>
